/* eslint-disable */
// @ts-nocheck
// prettier-ignore
// this is copy-pasted connatix snippet - DO NOT CHANGE UNLESS YOU ARE COPY-PASTING A NEW ONE
const injectConnatix = (cid) =>
    (function (n) {
        if (!window.cnx) {
            (window.cnx = {}), (window.cnx.cmd = []);
            var t = n.createElement('iframe');
            t.src = 'javascript:false';
            (t.display = 'none'),
                (t.onload = function () {
                    var n = t.contentWindow.document,
                        c = n.createElement('script');
                    (c.src = `//cd.connatix.com/connatix.player.js?cid=${cid}`),
                        c.setAttribute('async', '1'),
                        c.setAttribute('type', 'text/javascript'),
                        n.body.appendChild(c);
                }),
                n.head.appendChild(t);
        }
    })(document);

export default injectConnatix
